<template>
    <div id="content">
      <popup v-show="hasPopup"
             :popup-type="getPopupType"
             :popup-action="getPopupAction"
             @popup-action="executePopupAction" />

        <div class="inner_white">
          <div class="filter">
            <div class="field_left">
              <search-input input-class="search" v-model="formFields.search"></search-input>
            </div>
            <div class="field_right" v-if="$_loggedUser_action_allowed('deviceTypes')">
              <select-box
                  id="device_type"
                  :options="deviceTypesOptions"
                  v-model="formFields.id_type"
                  ref="iddevicetyperef"
              >
                <translate class="translate">Typ zařízení</translate>
              </select-box>
            </div>
            <div class="field_left">
              <select-box
                  id="operatorselect"
                  :options="operatorOptions"
                  v-model="formFields.operator"
                  ref="operatorselectref"
              >
                <translate class="translate">Operátor</translate>
              </select-box>
            </div>
            <a @click.stop.prevent="resetFilter" class="btn btn_action btn_grey btn_reset" :title="'Resetovat filtr' | translate" v-translate>Resetovat filtr</a>
          </div>
            <table class="vypis" ref="table_with_action_line" v-show="dataLoaded">
                <thead>
                <tr>
                  <th class="no_padding drag_drop"></th>
                  <th class="no_padding checkbox"></th>
                    <sorting-table-title
                            v-for="title in sortingTableTitles"
                            :key="title.id"
                            :column="title.column"
                            :sort="getActiveSort(title.column)"
                            @changeSorting="changeSorting"
                    >{{ title.name }}
                    </sorting-table-title>
                  <th class="no_padding edit"></th>
                </tr>
                </thead>
                <tbody>
                <unregistered-mac-address-row
                        v-for="entity in entities"
                        :entity="entity"
                        :key="entity.macAddress"
                        :selectedEntities="selectedEntities"
                        @input="select"
                ></unregistered-mac-address-row>
                </tbody>
            </table>

            <list-action-line
                    :entities="entities"
                    :selected-entities="filteredSelectedEntities"
                    :multiple-action-options="multipleActionOptions"
                    @select-all="toggleSelectAll"
                    @run-multiple-action="runMultipleAction"
                    :offset="formFields.offset"
                    :limit="formFields.limit"
                    :total-count="totalCount"
                    @limit="setLimit"
                    @offset="setOffset"
                    ref="action_line"
            ></list-action-line>
        </div>
    </div>
</template>

<script>
  import UnregisteredMacAddressRow from "@/components/views/registeredMacAddress/UnregisteredMacAddressRow"
	import listActions from "@/components/mixins/list-actions"
  import {prependOptions} from "@/utils/helpers";

	export default {
		name: "UnRegisteredMacAddressList",
    components: {UnregisteredMacAddressRow},
		mixins: [listActions],
		data() {
			return {
				moduleName: 'unregisteredMacAddress',
        formFields: {
          sort: {
            column: 'dmc.macAddress',
            direction: 'asc',
          },
          operator: 0,
          id_type: 0,
        },
        device_types: [],
        operators: [],
        sortingTableTitles: [
					{id: 1, name: this.$gettext('Mac adresa'), column: 'dmc.macAddress'},
					{id: 2, name: this.$gettext('Typ zařízení'), column: 'dt.code'},
          {id: 3, name: this.$gettext('Operátor'), column: 'o.name'},
        ],
			}
		},
		created(UnregisteredMacAddressService, DeviceTypeService, OperatorService) {
			this.entityService = UnregisteredMacAddressService;
      this.deviceTypeService = DeviceTypeService;
      this.operatorService = OperatorService;

      this.deviceTypeService.getEntitiesForSelectBox()
          .then((data) => {
            this.device_types = data['device_types']
          })
          .catch((error) => {
            this.setErrorMessage(error['error_message']);
          });
      this.operatorService.getOperators()
          .then((data) => {
            this.operators = data['operators']
          })
          .catch(error => {
            this.setErrorMessage(error['error_message'])
          });
			this.createdInit();
		},
    computed: {
      deviceTypesOptions() {
        if (this.device_types) {
          return prependOptions(this._.map(this.device_types, function (item) {
            return {id: item['id'], text: item['name']}
          }), this.$gettext('Všechny'))
        } else {
          return []
        }
      },
      operatorOptions() {
        if (this.operators) {
          let data = this._.map(this.operators, function (item) {
            return {id: item['id'], text: item['name']}
          });
          data.unshift({'id': 0, 'text':this.$gettext('Všechny')});
          return [...data];
        } else {
          return []
        }
      },
      multipleActionOptions() {
        return [
          {value: 'choose', text: this.$gettext('Vyberte akci')},
          {value: 'exportCsv', text: this.$gettext('Exportovat do CSV')},
          {value: 'registerMac', text: this.$gettext('Zaregistrovat MAC adresy')}
        ];
      },
      csvHeaders(){
        return {
          macAddress: {name: 'Mac Adresa'},
          device_type_code: {name: 'Typ zařízení'},
          operator_name: {name: 'Operátor'},
        }
      },
    },
    methods: {
      runMultipleAction(action, activeKey = 'active') {
        if (action === 'registerMac') {
          this.registerSelectedMacAddresses();
        }
        if (action === 'exportCsv'){
          this._exportCsv();
        }
      },
      loadAdditionalDefaults() {
        let anyChanges = false
        if (this.loadDefaultByKey('id_type')) {
          anyChanges = true
        }
        if (this.loadDefaultByKey('operator')) {
          anyChanges = true
        }
        return anyChanges
      },
      saveFilterValues() {
        this.saveSearch(this.formFields.search)
        this.setUserSetting('id_type', this.formFields.id_type);
        this.setUserSetting('operator', this.formFields.operator);
      },
      registerSelectedMacAddresses(){
        if(this.filteredSelectedEntities.length){
          this.$router.push({name: 'registeredMacAddressBatchNew', params: {mac_addresses:this.filteredSelectedEntities}});
        }else{
          this.setLoadingMessage();
          let formFields = {...this.formFields};
          delete formFields['limit'];
          delete formFields['offset'];
          delete formFields['sort'];
          this.entityService.getEntities(this._processFormFields(formFields))
              .then(data => {
                this.emptyMessage();
                let ids = data.unregisteredMacAddress.map(item => item.id);
                this.$router.push({name: 'registeredMacAddressBatchNew', params: {mac_addresses: ids}});
              });
        }
      },
    }
	}
</script>



// WEBPACK FOOTER //
// src/components/views/registeredMacAddress/UnregisteredMacAddressList.vue